import { Utils } from '@kineticdata/bundle-common';
import { List, Record } from 'immutable';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('app/home');

export const types = {
  FETCH_HOME_DATA_REQUEST: ns('FETCH_HOME_DATA_REQUEST'),

  FETCH_NEWS_REQUEST: ns('FETCH_NEWS_REQUEST'),
  FETCH_NEWS_SUCCESS: ns('FETCH_NEWS_SUCCESS'),
  FETCH_NEWS_FAILURE: ns('FETCH_NEWS_FAILURE'),

  FETCH_HOME_REQUESTS_REQUEST: ns('FETCH_HOME_REQUESTS_REQUEST'),
  FETCH_HOME_REQUESTS_SUCCESS: ns('FETCH_HOME_REQUESTS_SUCCESS'),
  FETCH_HOME_REQUESTS_FAILURE: ns('FETCH_HOME_REQUESTS_FAILURE'),
  SET_HOME_REQUESTS_COUNT: ns('SET_HOME_REQUESTS_COUNT'),

  FETCH_HOME_APPROVALS_REQUEST: ns('FETCH_HOME_APPROVALS_REQUEST'),
  FETCH_HOME_APPROVALS_SUCCESS: ns('FETCH_HOME_APPROVALS_SUCCESS'),
  FETCH_HOME_APPROVALS_FAILURE: ns('FETCH_HOME_APPROVALS_FAILURE'),
  SET_HOME_APPROVALS_COUNT: ns('SET_HOME_APPROVALS_COUNT'),

  FETCH_HOME_ACTIONS_REQUEST: ns('FETCH_HOME_ACTIONS_REQUEST'),
  FETCH_HOME_ACTIONS_SUCCESS: ns('FETCH_HOME_ACTIONS_SUCCESS'),
  FETCH_HOME_ACTIONS_FAILURE: ns('FETCH_HOME_ACTIONS_FAILURE'),
  SET_HOME_ACTIONS_COUNT: ns('SET_HOME_ACTIONS_COUNT'),

  FETCH_HOME_SURVEYS_COUNT: ns('FETCH_HOME_SURVEYS_COUNT'),
  FETCH_HOME_SURVEYS_COUNT_COMPLETE: ns('FETCH_HOME_SURVEYS_COUNT_COMPLETE'),
  SET_HOME_SURVEYS_COUNT: ns('SET_HOME_SURVEYS_COUNT'),

  FETCH_POPULAR_FORMS_REQUEST: ns('FETCH_POPULAR_FORMS_REQUEST'),
  FETCH_POPULAR_FORMS_SUCCESS: ns('FETCH_POPULAR_FORMS_SUCCESS'),
  FETCH_POPULAR_FORMS_FAILURE: ns('FETCH_POPULAR_FORMS_FAILURE'),

  FETCH_RECENT_FORMS_REQUEST: ns('FETCH_RECENT_FORMS_REQUEST'),
  FETCH_RECENT_FORMS_SUCCESS: ns('FETCH_RECENT_FORMS_SUCCESS'),
  FETCH_RECENT_FORMS_FAILURE: ns('FETCH_RECENT_FORMS_FAILURE'),

  FETCH_DATA_CENTER_STATUS_REQUEST: ns('FETCH_DATA_CENTER_STATUS_REQUEST'),
  FETCH_DATA_CENTER_STATUS_SUCCESS: ns('FETCH_DATA_CENTER_STATUS_SUCCESS'),
  FETCH_DATA_CENTER_STATUS_FAILURE: ns('FETCH_DATA_CENTER_STATUS_FAILURE'),

  FETCH_MAINTENANCE_SCHEDULE_REQUEST: ns('FETCH_MAINTENANCE_SCHEDULE_REQUEST'),
  FETCH_MAINTENANCE_SCHEDULE_SUCCESS: ns('FETCH_MAINTENANCE_SCHEDULE_SUCCESS'),
  FETCH_MAINTENANCE_SCHEDULE_FAILURE: ns('FETCH_MAINTENANCE_SCHEDULE_FAILURE'),
};

export const actions = {
  fetchHomeDataRequest: withPayload(types.FETCH_HOME_DATA_REQUEST),

  fetchNewsRequest: noPayload(types.FETCH_NEWS_REQUEST),
  fetchNewsSuccess: withPayload(types.FETCH_NEWS_SUCCESS),
  fetchNewsFailure: withPayload(types.FETCH_NEWS_FAILURE),

  fetchHomeRequestsRequest: withPayload(types.FETCH_HOME_REQUESTS_REQUEST),
  fetchHomeRequestsSuccess: withPayload(types.FETCH_HOME_REQUESTS_SUCCESS),
  fetchHomeRequestsFailure: withPayload(types.FETCH_HOME_REQUESTS_FAILURE),
  setHomeRequestsCount: withPayload(types.SET_HOME_REQUESTS_COUNT),

  fetchHomeApprovalsRequest: withPayload(types.FETCH_HOME_APPROVALS_REQUEST),
  fetchHomeApprovalsSuccess: withPayload(types.FETCH_HOME_APPROVALS_SUCCESS),
  fetchHomeApprovalsFailure: withPayload(types.FETCH_HOME_APPROVALS_FAILURE),
  setHomeApprovalsCount: withPayload(types.SET_HOME_APPROVALS_COUNT),

  fetchHomeActionsRequest: withPayload(types.FETCH_HOME_ACTIONS_REQUEST),
  fetchHomeActionsSuccess: withPayload(types.FETCH_HOME_ACTIONS_SUCCESS),
  fetchHomeActionsFailure: withPayload(types.FETCH_HOME_ACTIONS_FAILURE),
  setHomeActionsCount: withPayload(types.SET_HOME_ACTIONS_COUNT),

  fetchHomeSurveysCount: noPayload(types.FETCH_HOME_SURVEYS_COUNT),
  fetchHomeSurveysCountComplete: withPayload(
    types.FETCH_HOME_SURVEYS_COUNT_COMPLETE,
  ),
  setHomeSurveysCount: withPayload(types.SET_HOME_SURVEYS_COUNT),

  fetchPopularFormsRequest: noPayload(types.FETCH_POPULAR_FORMS_REQUEST),
  fetchPopularFormsSuccess: withPayload(types.FETCH_POPULAR_FORMS_SUCCESS),
  fetchPopularFormsFailure: withPayload(types.FETCH_POPULAR_FORMS_FAILURE),

  fetchRecentFormsRequest: noPayload(types.FETCH_RECENT_FORMS_REQUEST),
  fetchRecentFormsSuccess: withPayload(types.FETCH_RECENT_FORMS_SUCCESS),
  fetchRecentFormsFailure: withPayload(types.FETCH_RECENT_FORMS_FAILURE),

  fetchDataCenterStatusRequest: noPayload(
    types.FETCH_DATA_CENTER_STATUS_REQUEST,
  ),
  fetchDataCenterStatusSuccess: withPayload(
    types.FETCH_DATA_CENTER_STATUS_SUCCESS,
  ),
  fetchDataCenterStatusFailure: withPayload(
    types.FETCH_DATA_CENTER_STATUS_FAILURE,
  ),

  fetchMaintenanceScheduleRequest: noPayload(
    types.FETCH_MAINTENANCE_SCHEDULE_REQUEST,
  ),
  fetchMaintenanceScheduleSuccess: withPayload(
    types.FETCH_MAINTENANCE_SCHEDULE_SUCCESS,
  ),
  fetchMaintenanceScheduleFailure: withPayload(
    types.FETCH_MAINTENANCE_SCHEDULE_FAILURE,
  ),
};

export const ListState = Record({
  error: null,
  data: null,
  count: null,
});

export const State = Record({
  news: ListState(),
  requests: ListState(),
  approvals: ListState(),
  actions: ListState(),
  surveys: ListState(),
  popularForms: ListState(),
  recentForms: ListState(),
  dataCenterStatus: ListState(),
  maintenanceSchedule: ListState(),
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_NEWS_REQUEST:
      return state.setIn(['news', 'error'], null);
    case types.FETCH_NEWS_SUCCESS:
      return state
        .setIn(['news', 'data'], List(payload.data))
        .setIn(
          ['news', 'count'],
          typeof payload.count === 'number'
            ? payload.count < 1000
              ? payload.count
              : '999+'
            : null,
        );
    case types.FETCH_NEWS_FAILURE:
      return state.setIn(['news', 'error'], payload);

    case types.FETCH_HOME_REQUESTS_REQUEST:
      return state.setIn(['requests', 'error'], null);
    case types.FETCH_HOME_REQUESTS_SUCCESS:
      return state
        .setIn(
          ['requests', 'data'],
          payload.data ? List(payload.data) : state.getIn(['requests', 'data']),
        )
        .setIn(
          ['requests', 'count'],
          typeof payload.count === 'number'
            ? payload.count < 1000
              ? payload.count
              : '999+'
            : null,
        );
    case types.FETCH_HOME_REQUESTS_FAILURE:
      return state.setIn(['requests', 'error'], payload);
    case types.SET_HOME_REQUESTS_COUNT:
      return state.setIn(
        ['requests', 'count'],
        typeof payload === 'number'
          ? payload < 1000
            ? payload
            : '999+'
          : null,
      );

    case types.FETCH_HOME_APPROVALS_REQUEST:
      return state.setIn(['approvals', 'error'], null);
    case types.FETCH_HOME_APPROVALS_SUCCESS:
      return state
        .setIn(
          ['approvals', 'data'],
          payload.data
            ? List(payload.data)
            : state.getIn(['approvals', 'data']),
        )
        .setIn(
          ['approvals', 'count'],
          typeof payload.count === 'number'
            ? payload.count < 1000
              ? payload.count
              : '999+'
            : null,
        );
    case types.FETCH_HOME_APPROVALS_FAILURE:
      return state.setIn(['approvals', 'error'], payload);
    case types.SET_HOME_APPROVALS_COUNT:
      return state.setIn(
        ['approvals', 'count'],
        typeof payload === 'number'
          ? payload < 1000
            ? payload
            : '999+'
          : null,
      );

    case types.FETCH_HOME_ACTIONS_REQUEST:
      return state.setIn(['actions', 'error'], null);
    case types.FETCH_HOME_ACTIONS_SUCCESS:
      return state
        .setIn(
          ['actions', 'data'],
          payload.data ? List(payload.data) : state.getIn(['actions', 'data']),
        )
        .setIn(
          ['actions', 'count'],
          typeof payload.count === 'number'
            ? payload.count < 1000
              ? payload.count
              : '999+'
            : null,
        );
    case types.FETCH_HOME_ACTIONS_FAILURE:
      return state.setIn(['actions', 'error'], payload);
    case types.SET_HOME_ACTIONS_COUNT:
      return state.setIn(
        ['actions', 'count'],
        typeof payload === 'number'
          ? payload < 1000
            ? payload
            : '999+'
          : null,
      );

    case types.FETCH_HOME_SURVEYS_COUNT:
      return state.setIn(['surveys', 'error'], null);
    case types.FETCH_HOME_SURVEYS_COUNT_COMPLETE:
      return payload.error
        ? state
            .setIn(['surveys', 'error'], payload.error)
            .setIn(['surveys', 'count'], null)
        : state.setIn(
            ['surveys', 'count'],
            typeof payload.count === 'number'
              ? payload.count < 1000
                ? payload.count
                : '999+'
              : null,
          );
    case types.SET_HOME_SURVEYS_COUNT:
      return state.setIn(
        ['surveys', 'count'],
        typeof payload === 'number'
          ? payload < 1000
            ? payload
            : '999+'
          : null,
      );

    case types.FETCH_POPULAR_FORMS_REQUEST:
      return state.setIn(['popularForms', 'error'], null);
    case types.FETCH_POPULAR_FORMS_SUCCESS:
      return state.setIn(['popularForms', 'data'], List(payload.data));
    case types.FETCH_POPULAR_FORMS_FAILURE:
      return state.setIn(['popularForms', 'error'], payload);

    case types.FETCH_RECENT_FORMS_REQUEST:
      return state.setIn(['recentForms', 'error'], null);
    case types.FETCH_RECENT_FORMS_SUCCESS:
      return state.setIn(['recentForms', 'data'], List(payload.data));
    case types.FETCH_RECENT_FORMS_FAILURE:
      return state.setIn(['recentForms', 'error'], payload);

    case types.FETCH_DATA_CENTER_STATUS_REQUEST:
      return state.setIn(['dataCenterStatus', 'error'], null);
    case types.FETCH_DATA_CENTER_STATUS_SUCCESS:
      return state
        .setIn(['dataCenterStatus', 'data'], List(payload.data))
        .setIn(
          ['dataCenterStatus', 'count'],
          typeof payload.count === 'number'
            ? payload.count
            : (Array.isArray(payload.data) && payload.data.length) || 0,
        );
    case types.FETCH_DATA_CENTER_STATUS_FAILURE:
      return state.setIn(['dataCenterStatus', 'error'], payload);

    case types.FETCH_MAINTENANCE_SCHEDULE_REQUEST:
      return state.setIn(['maintenanceSchedule', 'error'], null);
    case types.FETCH_MAINTENANCE_SCHEDULE_SUCCESS:
      return state.setIn(['maintenanceSchedule', 'data'], List(payload.data));
    case types.FETCH_MAINTENANCE_SCHEDULE_FAILURE:
      return state.setIn(['maintenanceSchedule', 'error'], payload);

    default:
      return state;
  }
};
